import { bool, eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const TextEditorProperties = {
    className: {
        type: string,
    },
    enabled: {
        defaultValue: true,
        type: bool,
    },
    onBlur: {
        type: eventListener,
    },
    onChange: {
        type: eventListener,
    },
    onFocus: {
        type: eventListener,
    },
    onKeyDown: {
        type: eventListener,
    },
    onKeyPress: {
        type: eventListener,
    },
    onKeyUp: {
        type: eventListener,
    },
    readOnly: {
        defaultValue: false,
        type: bool,
    },
    textOnly: {
        defaultValue: false,
        type: bool,
    },
    value: {
        defaultValue: '',
        type: string.notEnumerable(),
    },
};
export { TextEditorProperties, };
//# sourceMappingURL=text-editor-types.js.map